/**
 * HERO FULLSKJERM - FORSIDE
 *
 * Eneste jobb: velge HVILKEN video som skal lastes, og starte den.
 *
 * Hvorfor det trengs i det hele tatt: seksjonen kan ha bade en desktop- og en mobilvideo. Bilder
 * loser dette med <picture>, der nettleseren laster nøyaktig en kilde. <video> har ingen tilsvarende
 * mekanisme - media-attributtet pa <source> er fjernet fra spesifikasjonen og ignoreres. Legger man
 * begge videoene i DOM med ekte src, laster nettleseren begge to, ogsa den som er skjult med CSS.
 *
 * Derfor star kildene som data-src, og denne filen setter src pa den ene som faktisk skal spilles.
 * Den skjulte videoen laster aldri en byte.
 *
 * Ved prefers-reduced-motion gjor vi ingenting: plakatbildet ligger allerede i DOM under videoen,
 * og CSS skjuler videolaget. Ingen nedlasting, ingen bevegelse.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 699px)';

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function isMobileViewport() {
    return typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches;
  }

  function activateVideo(video) {
    if (!video || video.dataset.heroActivated === 'true') return;
    video.dataset.heroActivated = 'true';

    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      source.src = source.getAttribute('data-src');
      source.removeAttribute('data-src');
    });

    // is-playing settes forst nar det faktisk kommer bilder, ikke nar play() kalles. Da rekker
    // aldri en tom, svart <video> a bli synlig over plakatbildet.
    video.addEventListener(
      'playing',
      function () {
        video.classList.add('is-playing');
      },
      { once: true }
    );

    video.load();

    var attempt = video.play();

    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {
        // Autoplay kan blokkeres selv nar videoen er muted (strommesparing, iOS Low Power Mode).
        // Plakatbildet blir da staende, som er nettopp det vi vil - ingen feilmelding, ingen tom flate.
      });
    }
  }

  function activateIframe(wrap) {
    if (!wrap || wrap.dataset.heroActivated === 'true') return;

    var src = wrap.getAttribute('data-src');
    if (!src) return;

    wrap.dataset.heroActivated = 'true';

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', wrap.getAttribute('data-title') || '');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('loading', 'lazy');

    // Rammen er dekorativ bakgrunn. Vi far ingen avspillingshendelse fra YouTube/Vimeo uten deres
    // eget API, sa vi fader inn pa load og lar plakatbildet dekke fram til da.
    iframe.addEventListener('load', function () {
      wrap.classList.add('is-playing');
    });

    wrap.appendChild(iframe);
  }

  function initRoot(root) {
    if (!root) return;

    var layer = root.querySelector('[data-hero-video-layer]');
    if (!layer) return;

    if (prefersReducedMotion()) return;

    var iframeWrap = layer.querySelector('[data-hero-iframe]');
    if (iframeWrap) {
      activateIframe(iframeWrap);
      return;
    }

    var mobile = layer.querySelector('[data-hero-video="mobile"]');
    var desktop = layer.querySelector('[data-hero-video="desktop"]');

    // Faller tilbake til den andre kilden nar bare en av dem er fylt ut i temaeditoren.
    var chosen = isMobileViewport() ? mobile || desktop : desktop || mobile;

    if (!chosen) return;

    // Den vi ikke valgte skal ikke ligge og ta plass i visningen.
    [mobile, desktop].forEach(function (video) {
      if (video && video !== chosen) video.remove();
    });

    activateVideo(chosen);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hero-fullscreen]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Temaeditoren bygger seksjonen pa nytt ved hver endring; da ma videoen aktiveres igjen.
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var root = event.target.querySelector('[data-hero-fullscreen]');
    if (root) initRoot(root);
  });
})();
